// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-components-DepartmentProducts-category-module__root","title":"applications-components-ProductsApp-components-DepartmentProducts-category-module__title","content":"applications-components-ProductsApp-components-DepartmentProducts-category-module__content"};
    if(module.hot) {
      // 1791528099344
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  